import * as React from "react";
import { cn } from "../../lib/utils";

interface ToggleSwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  description?: string;
  iconOn?: React.ReactNode;
  iconOff?: React.ReactNode;
}

const ToggleSwitch = React.forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ className, label, description, iconOn, iconOff, ...props }, ref) => {
    return (
      <label className={cn("inline-flex items-center gap-3 cursor-pointer", className)}>
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only peer"
            ref={ref}
            {...props}
          />
          <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#daed6e] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-[#daed6e] transition-colors duration-300 ease-in-out">
            {/* Icons inside toggle */}
            {iconOn && (
              <div className="absolute inset-y-0 right-1.5 flex items-center justify-center opacity-0 peer-checked:opacity-100 transition-opacity duration-300 text-white">
                {iconOn}
              </div>
            )}
            {iconOff && (
              <div className="absolute inset-y-0 left-1.5 flex items-center justify-center opacity-100 peer-checked:opacity-0 transition-opacity duration-300 text-gray-500">
                {iconOff}
              </div>
            )}
          </div>
        </div>
        {(label || description) && (
          <div className="flex flex-col">
            {label && (
              <span className="text-sm font-medium text-gray-700">{label}</span>
            )}
            {description && (
              <span className="text-xs text-gray-500">{description}</span>
            )}
          </div>
        )}
      </label>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export { ToggleSwitch }; 